module.exports = __webpack_public_path__ + "static/media/bruno.4b148a82.png";